import { render, staticRenderFns } from "./StampShopDetail.vue?vue&type=template&id=01093fdc&scoped=true&"
import script from "./StampShopDetail.vue?vue&type=script&lang=js&"
export * from "./StampShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./StampShopDetail.vue?vue&type=style&index=0&id=01093fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01093fdc",
  null
  
)

export default component.exports